// extracted by mini-css-extract-plugin
export default {"statRow":"StatRow_statRow__CHyQY"};